"use strict";
/**
 * @file Created on Fri Aug 24 2018
 * @author VBr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NumberInRangeValidator_1 = require("./NumberInRangeValidator");
/**
 * Validator that checkes number's in range of a slider
 */


var SliderValidator =
/*#__PURE__*/
function (_NumberInRangeValidat) {
  _inherits(SliderValidator, _NumberInRangeValidat);

  function SliderValidator(min, max) {
    var _this;

    _classCallCheck(this, SliderValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SliderValidator).call(this, min, max));
    _this.min = min;
    _this.max = max;
    return _this;
  }

  return SliderValidator;
}(NumberInRangeValidator_1.NumberInRangeValidator);

exports.SliderValidator = SliderValidator;